// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"26":"28bb2a50","52":"34977e26","72":"5478f1f1","423":"afe8ab43","522":"c8ca9412","564":"709f8660"}[chunkId] + ".css";
};